import React from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import advanced from 'dayjs/plugin/advancedFormat'
import Icon from '../../../../atoms/Icon'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(advanced)

function linkedContactName (event) {
  const links = Array.isArray(event?.linked_to) ? event.linked_to : []
  const first = links[0]?.name
  if (!first) return null
  return links.length > 1 ? `${first} (+${links.length - 1})` : first
}

function formatRange (event) {
  const start = event.starts_at ? dayjs(event.starts_at) : null
  const end = event.ends_at ? dayjs(event.ends_at) : null
  if (!start?.isValid()) return null
  const dayLabel = start.format('ddd M/D')
  if (event.all_day) return `${dayLabel} (all day)`
  if (end?.isValid()) {
    return `${dayLabel}, ${start.format('h:mma')} to ${end.format('h:mma z')}`
  }
  return `${dayLabel}, ${start.format('h:mma z')}`
}

function WealthboxEventRow ({ event, onClick }) {
  const rangeFormatted = formatRange(event)
  const isCancelled = event.state === 'cancelled'

  return (
    <div style={{ borderBottom: '1px solid var(--color-neutral-200)' }}>
      <div
        role='button'
        tabIndex={0}
        onClick={onClick}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick() } }}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          padding: '12px 1.5rem',
          cursor: 'pointer',
          userSelect: 'none'
        }}
      >
        <div style={{
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          color: isCancelled ? 'var(--text-color-subtle)' : 'var(--color-primary-500)'
        }}
        >
          <Icon name={isCancelled ? 'block' : 'calendar'} customSize='18px' />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            className='font-size-xs' style={{
              color: 'var(--text-color-subtle)',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            {linkedContactName(event) || 'Unlinked'}
          </div>
          <div
            className='font-size-sm' style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              textDecoration: isCancelled ? 'line-through' : 'none'
            }}
          >
            {event.title || 'Untitled Event'}
          </div>
          {rangeFormatted ? (
            <div
              className='font-size-xs' style={{
                color: 'var(--text-color-subtle)',
                marginTop: '2px'
              }}
            >
              {rangeFormatted}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}

WealthboxEventRow.propTypes = {
  event: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
}

export default WealthboxEventRow
